module.exports = __webpack_public_path__ + "img/prl.4c5c3157.svg";